import * as React from "react";
import { StickyCallToAction } from "@grandvisionhq/common";
import { SunglassesCTA } from "../../../../../../SunglassesCTA/modules/EcommContent/SunglassesEcommContent/components/SunglassesCTA/SunglassesCTA.js";
import { useSunglassesPriceFrom } from "../../../../../../../hooks/modules/EcommContent/SunglassesEcommContent/hooks/use-sunglasses-price-from.js";
import { StickyPriceView } from "../../../../../../../../../StickyCta/components/modules/StickyCta/components/StickyPriceView.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const SunglassesStickyCTA = ({ className }) => {
  const { displayPrice } = useProductData();
  const { fromPricePrefix } = useSunglassesPriceFrom();
  return /* @__PURE__ */ React.createElement(
    StickyCallToAction,
    {
      className,
      button: /* @__PURE__ */ React.createElement(SunglassesCTA, null),
      price: /* @__PURE__ */ React.createElement(StickyPriceView, { displayPrice, prefix: fromPricePrefix })
    }
  );
};
export {
  SunglassesStickyCTA
};
//# sourceMappingURL=SunglassesStickyCTA.js.map
